import moment from 'moment'
import { orderStateList2, orderStateList3 } from '@/utils/textFile'
export default ({ data }) => {
  let orderStateList = []
  console.log('---data---',data)
  if (data.orderItemList[0].comboType){
    orderStateList = orderStateList3
  }else {
    orderStateList = orderStateList2
  }
  return {
    title: '基础信息',
    form: [
      {
        type: 'textGroup',
        value: [
          {
            name: '订单编号',
            key: 'orderSn',
            display: data.orderSn,
          },
          {
            name: '订单状态',
            display: data.status,
            value: data.refundId
              ? '待退款'
              : (orderStateList.find((e) => e.value == data.status) || { text: '' }).text,
          },
          {
            name: '店铺名称',
            key: 'shopName',
            display: data.shopName,
          },
          {
            name: '入住时间',
            value: data.orderItemList ? moment(data.orderItemList[0].checkInTime).format('YYYY年MM月DD日') : '',
            display: data.orderItemList ? data.orderItemList[0].checkInTime : false,
          },
          {
            name: '用户姓名',
            key: 'buyName',
            display: data.buyName,
          },
          {
            name: '离店时间',
            value: data.orderItemList ? moment(data.orderItemList[0].leaveTime).format('YYYY年MM月DD日') : '',
            display: data.orderItemList ? data.orderItemList[0].leaveTime : false,
          },
          {
            name: '手机号',
            key: 'buyPhone',
            display: data.buyPhone,
          },
          {
            name: '订单类型',
            value: ["普通订单","秒杀订单","推广订单","分销订单"][data.orderType],
            display:true
          },
          {
            name: '分销人',
            value: data.shareUserPhone,
            display: data.orderType == 3
          },
          {
            name: '订单佣金',
            value: data.commissionAmount,
            display: data.orderType == 3
          },
          {
            name: '备注',
            key: 'remark',
            display: data.remark,
          },
        ].filter((e) => e.display),
      },
    ],
  }
}
